__turbopack_context__.v({
  "accordionList": "RetailerPage-module-scss-module__XAMP2a__accordionList",
  "asideCard": "RetailerPage-module-scss-module__XAMP2a__asideCard",
  "asideHeading": "RetailerPage-module-scss-module__XAMP2a__asideHeading",
  "asideLogo": "RetailerPage-module-scss-module__XAMP2a__asideLogo",
  "closedHour": "RetailerPage-module-scss-module__XAMP2a__closedHour",
  "companyInformation": "RetailerPage-module-scss-module__XAMP2a__companyInformation",
  "companyInformationKey": "RetailerPage-module-scss-module__XAMP2a__companyInformationKey",
  "companyInformationList": "RetailerPage-module-scss-module__XAMP2a__companyInformationList",
  "companyInformationValue": "RetailerPage-module-scss-module__XAMP2a__companyInformationValue",
  "descriptionList": "RetailerPage-module-scss-module__XAMP2a__descriptionList",
  "descriptionListLabel": "RetailerPage-module-scss-module__XAMP2a__descriptionListLabel",
  "descriptionListValue": "RetailerPage-module-scss-module__XAMP2a__descriptionListValue",
  "fade-in": "RetailerPage-module-scss-module__XAMP2a__fade-in",
  "featuredImage": "RetailerPage-module-scss-module__XAMP2a__featuredImage",
  "informationMain": "RetailerPage-module-scss-module__XAMP2a__informationMain",
  "informationMainAside": "RetailerPage-module-scss-module__XAMP2a__informationMainAside",
  "informationMainSection": "RetailerPage-module-scss-module__XAMP2a__informationMainSection",
  "no-transform": "RetailerPage-module-scss-module__XAMP2a__no-transform",
  "openingHours": "RetailerPage-module-scss-module__XAMP2a__openingHours",
  "openingHoursInfo": "RetailerPage-module-scss-module__XAMP2a__openingHoursInfo",
  "openingHoursMap": "RetailerPage-module-scss-module__XAMP2a__openingHoursMap",
  "rotate": "RetailerPage-module-scss-module__XAMP2a__rotate",
});
